export default __webpack_public_path__ + "static/media/login-image.76723360.svg";